export const iconFontAwesomeCommunicationPhoneSlash = (
	<i className="fa-solid fa-phone-slash"></i>
);
